import {Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter} from "@/components/ui/dialog";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Form, FormField, FormItem, FormLabel, FormControl, FormMessage} from "@/components/ui/form";
import {useForm} from "react-hook-form";
import {usePage} from "@inertiajs/react";
import {NurseEditFormPayload, NurseUpdateSchema} from "@/lib/types/forms.ts";
import {zodResolver} from "@hookform/resolvers/zod";
import {Nurse} from "@/lib/types/models.ts";
import {useEffect} from "react";

interface EditNurseDialogProps {
    isOpen: boolean,
    onOpenChange: (open: boolean) => void,
    onUpdate: (data: NurseEditFormPayload) => Promise<void>,
    nurse: Nurse
}


export default function EditNurseDialog({
                                            isOpen,
                                            onOpenChange,
                                            onUpdate,
                                            nurse
                                        }: EditNurseDialogProps) {
    const {translations} = usePage().props as unknown as { translations: any };
    const t = translations.edit_dialog;

    const form = useForm<NurseEditFormPayload>({
        resolver: zodResolver(NurseUpdateSchema),
        defaultValues: {
            name: nurse.name ?? "",
            username: nurse.username ?? "",
            phone_number: nurse.phone_number ?? "",
        },
    });

    useEffect(() => {
        form.reset({
            name: nurse.name ?? "",
            username: nurse.username ?? "",
            phone_number: nurse.phone_number ?? "",
        });
    }, [nurse]);

    const handleSubmit = async (data: NurseEditFormPayload) => {
        await onUpdate(data);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{t.title}</DialogTitle>
                </DialogHeader>

                <Form {...form}>
                    <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
                        <FormField
                            control={form.control}
                            name="name"
                            render={({field}) => (
                                <FormItem>
                                    <FormLabel>{t.labels.name}</FormLabel>
                                    <FormControl>
                                        <Input {...field}/>
                                    </FormControl>
                                    <FormMessage/>
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="username"
                            render={({field}) => (
                                <FormItem>
                                    <FormLabel>{t.labels.username}</FormLabel>
                                    <FormControl>
                                        <Input {...field}/>
                                    </FormControl>
                                    <FormMessage/>
                                </FormItem>
                            )}/>
                        <FormField
                            control={form.control}
                            name="phone_number"
                            render={({field}) => (
                                <FormItem>
                                    <FormLabel>{t.labels.phone}</FormLabel>
                                    <FormControl>
                                        <Input {...field}/>
                                    </FormControl>
                                    <FormMessage/>
                                </FormItem>
                            )}/>

                        <DialogFooter className="flex justify-end gap-2">
                            <Button variant="outline" type="button" onClick={() => onOpenChange(false)}>
                                {t.buttons.cancel}
                            </Button>

                            <Button type="submit">
                                {t.buttons.update}
                            </Button>
                        </DialogFooter>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    );
}